import { GridSizeChangedEvent } from "ag-grid-community";

/**
 * Executes when Grid size updates
 * @param gridSizeChangedEvent 
 */
export const onGridSizeChanged = (gridSizeChangedEvent:GridSizeChangedEvent) => {
    const {clientWidth, clientHeight, columnApi} = gridSizeChangedEvent;
    // Updates the column widths
    columnApi.sizeColumnsToFit(clientWidth);
  }

//Dependencies for dollar formatter
const isNumber = (char: any): boolean=>!isNaN(parseInt(char));
const formatNumber = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});
//Formate number into dollar format  
export const valueFormatterUSD = (p: any) => isNumber(p.value) && formatNumber.format(p.value);
  
/**
 *  Input format is yyyy-mm-ddThh:mm:ss
 * @param params 
 * @returns 'yyyy-mm-dd hh:mm'
 */
export const dateFormatter = (params:any) => params?.value?.substr(0, 16).replace('T', ' ');